import React, { useEffect, useState } from "react";
import ImgComp from "../Component/ImgComp";
import PaymentContent from "../Modules/PaymentContent";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PaymentContentNew from "../Modules/PaymentContentNew";
import axios from "axios";
import { adminapiUrl } from "../Utils/constants";

const PaymentPage = () => {

  const [userDetailsState,setUserDetails] = useState()
  const storeSel = useSelector((state) => state);
  const userDetails = storeSel?.UrlData?.userDetails;
  const navigate = useNavigate();

  
  const [categorySlug, setCategorySlug] = useState(null);
  const [categories, setCategories] = useState(null);
  const { category } = useParams();

  const [categoriesMap, setCategoriesMap]  = useState({});

  useEffect(()=>{
    setUserDetails(userDetails)
  },[])

  useEffect(() => {
    if (
      userDetails &&
      userDetails?.startdate === null ||
      userDetails?.name === null 
    ) {
      const pathSegments = window.location.pathname.split('/');      
      // Remove the last segment to go back one level
      pathSegments.pop();    

      // Construct the new URL
      const newUrl = pathSegments.join('/');    

      // Navigate to the new URL
      navigate(newUrl);
    }
  }, [userDetailsState]);

  
  useEffect(() => {
    // const queryParams = new URLq(window.location.search);

    // console.log("query_params => ", queryParams)

    // const catSlug = queryParams.get("category")

    if(category) setCategorySlug(category)
    
      console.log("Cat slug --->", category)

      const getCategories = async () => {
        const res = await axios.get(
          adminapiUrl+"/read_allbranch_alltypes_allplans",
          // "https://admin-api.bodyprocoach.com/admin/read_allbranch_alltypes_allplans",
          {
            headers: {
              "Content-Type": "application/json",
            },
            mode: "no-cors",
          }
        );
    
        const data = res.data.data;
        setCategories(data?.All_categories);
        if(data?.All_categories) {
          const cat_slug_map = {}
          data?.All_categories.map((cat, index) => {
            if(index < 3){ 
              cat_slug_map[cat.slug] = 'sweat' 
              
            }
            else{ 
              cat_slug_map[cat.slug] = 'bootcamp' 
             
            } 
          })
          console.log("CAT SLUG MAP --> ", cat_slug_map)
          setCategoriesMap(cat_slug_map);
        }

        console.log("categories in sessions => ", data);
      };
      getCategories();

  }, [category]);

  
  useEffect(() => {
    if(categoriesMap && categorySlug) {
    if(categoriesMap[categorySlug] == "bootcamp") document.documentElement.style.setProperty('--global-theme', '#9900FF');
    else if(categoriesMap[categorySlug] == "sweat") document.documentElement.style.setProperty('--global-theme', '#e6001e');
    }
  }, [categorySlug, categoriesMap])

  
  return (
    <>
      <div className="home-page payment-page start-page">
      {categoriesMap[categorySlug] ? (
      <>
        <ImgComp appname = {categories?.find(cat => cat?.slug == categorySlug)?.uid == 10 ? "bootcamp" : "sweat"} />

        <PaymentContentNew  appname = {categories?.find(cat => cat?.slug == categorySlug)?.uid == 10 ? "bootcamp" : "sweat"} />
        </>
      ) : <p>Loading...</p>}
      </div>
    </>
  );
};

export default PaymentPage;
